<template>
    <div class="stream_formation_box">
        <div class="inform_tit"> 
            <div @click="cancel" class='cancel_box'>
                <i class="el-icon-back myback_icon"></i> Back
            </div>
        </div>
		<template v-if="isPro">
			<div class="informdata_tit">Revenue Stream</div>
			<div v-if="loading" class="loading-icon">
				<i class="el-icon-loading"></i>
			</div>
			<div v-else>
				<StreamBox v-for="(item, index) in list" :key="index" :type="item.type" :tableData="item.tableData" @refresh="getList()"/>
			</div>
		</template>
		<template v-if="isDoneLoad && !isPro">
			<div class="error-container d-flex align-items-center justify-content-center">
                <card-unauthorized></card-unauthorized>
            </div>
		</template>

		<el-dialog :visible.sync="isTrialEnd" class="peiso-modal" width="810px" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
			<free-trial-notice :info="venueDiscountDetailsPojo" :isPro="isPro" @close-notice="closeOrLogoutVenue"></free-trial-notice>
		</el-dialog>
    </div>
</template>

<script>
import api from '../../api/api'
import streambox from './streambox.vue'
import cardUnauthorized from '@/components/card/unauthorized';
import freeTrialNotice from '@/components/modal/freeTrialNotice';
export default {
    data() {
        return {
			loading: true,
			list:[
				/*{
					type: 'Revenue',
					tableData: [
						{
							commission: 0,
							createTime: 1664008714447,
							id: 207,
							incomeName: "Open Table Bookings",
							incomeType: 1,
							isCanNotBeDeleted: 0,
							updateTime: 1664008714447,
							venueId: 105
						},
						{
							commission: 0.1,
							createTime: 1664011799325,
							id: 210,
							incomeName: "Ola",
							incomeType: 2,
							isCanNotBeDeleted: 0,
							updateTime: 1664011799325,
							venueId: 105
						}
					]
				},
				{
					type: 'Expense',
					tableData: [
						{
							commission: 0,
							createTime: 1664008714447,
							id: 207,
							incomeName: "Open Table Bookings",
							incomeType: 1,
							isCanNotBeDeleted: 0,
							updateTime: 1664008714447,
							venueId: 105
						},
						{
							commission: 0.1,
							createTime: 1664011799325,
							id: 210,
							incomeName: "Ola",
							incomeType: 2,
							isCanNotBeDeleted: 0,
							updateTime: 1664011799325,
							venueId: 105
						}
					]
				}*/
			],
			isPro: false,
			isDoneLoad: false,
			venueDiscountDetailsPojo: null,
      		isTrialEnd: false,
        }
    },
    methods: {
        cancel(){
            this.$router.push({path:'/setting'})
		},
		getList(){
			this.loading=true
			this.list = []
			let pat={
				pageNum:1,
				pageSize:1000
			}
			api.getStreanList(pat,this.callback)
		},
		callback(res,status){
			this.loading=false;
			let {code , message ,data} = res.data
            if(code==0){
				if (data.revenueList && data.revenueList[0]){
					let temp = []
					data.revenueList.forEach(i => {
						console.log('i: ', i);
						let formatCommission = Number(Utils.formatSplit(i.commission * 100))
						temp.push({
							commission: i.incomeType === 2 ? formatCommission : i.commission,
							createTime: i.createTime,
							id: i.id,
							incomeName:  i.incomeName == 'Mr Yum' ? 'Me&U' : i.incomeName,
							incomeType: i.incomeType,
							isCanNotBeDeleted: i.isCanNotBeDeleted,
							updateTime: i.updateTime,
							venueId: i.venueId,
							modifyFlag: i.modifyFlag
						})
					})
					this.list.push({
						type: 'Revenue',
						tableData: temp
					})
				} else {
					this.list.push({
						type: 'Revenue',
						tableData: []
					})
				}
				if (data.deliveryList && data.deliveryList[0]){
					let temp = []
					data.deliveryList.forEach(i => {
						let formatCommission = Number(Utils.formatSplit(i.commission * 100))
						temp.push({
							commission: i.incomeType === 2 ? formatCommission : i.commission,
							createTime: i.createTime,
							id: i.id,
							incomeName: i.incomeName,
							incomeType: i.incomeType,
							isCanNotBeDeleted: i.isCanNotBeDeleted,
							updateTime: i.updateTime,
							venueId: i.venueId
						})
					})
					this.list.push({
						type: 'Delivery',
						tableData: temp
					})
				} else {
					this.list.push({
						type: 'Delivery',
						tableData: []
					})
				}
				if (data.expensesList && data.expensesList[0]){
					let temp = []
					data.expensesList.forEach(i => {
						let formatCommission = Number(Utils.formatSplit(i.commission * 100))
						temp.push({
							commission: i.incomeType === 2 ? formatCommission : i.commission,
							createTime: i.createTime,
							id: i.id,
							incomeName: i.incomeName,
							incomeType: i.incomeType,
							isCanNotBeDeleted: i.isCanNotBeDeleted,
							updateTime: i.updateTime,
							venueId: i.venueId
						})
					})
					this.list.push({
						type: 'Expenses',
						tableData: temp
					})
				} else {
					this.list.push({
						type: 'Expenses',
						tableData: []
					})
				}
            }else{
                Utils.alert('',message,'error')
            }
		},
		nameBlur(){ // name失去焦点
			if(!this.name)
				this.isName=true;
			else
			this.isName=false;
		},
		closeOrLogoutVenue(isSubscribe) {
			if (isSubscribe) {
				this.isTrialEnd = false
				return
			}
			if (this.venueDiscountDetailsPojo.remainingDays <= 0) {
				this.$root.$emit('logout-venue')
			} else {
				const isContUsingTrial = sessionStorage.getItem('isContUsingTrial')
				if (isContUsingTrial == '0') {
				sessionStorage.setItem('isContUsingTrial', '1')
				}
				this.isTrialEnd = false
			}
		}
	},
	mounted() {
		this.getList()
		this.$root.$on('isPro', (isPro, others) => { 
            this.isPro = isPro
            this.isDoneLoad = true

			const isContUsingTrial = sessionStorage.getItem('isContUsingTrial')
			if (others.venueDiscountDetailsPojo && others.venueDiscountDetailsPojo.remainingDays <= 3 && isContUsingTrial == '0') {
				this.venueDiscountDetailsPojo = others.venueDiscountDetailsPojo
				this.isTrialEnd =  true
			}
        })
	},
	components: { 
		StreamBox: streambox,
		cardUnauthorized: cardUnauthorized,
		freeTrialNotice: freeTrialNotice
	},
}
</script>

<style lang="scss">
.loading-icon{
	text-align:center;
	font-size:26px;
	color:var(--text-color);
	padding: 50px 0;
}
.hat{
	width: 100%;
	height: 60px;
	background: var(--background-color-2);
	box-sizing: border-box;
	line-height: 60px;
	padding: 10px 30px 0 30px;
	font-size: 20px;
	// font-family: PingFang SC-Semibold, PingFang SC;
	color: var(--text-color);
	line-height: 40px;
	.btn{
		float: right !important;
		width: 100px !important;
		height: 40px !important;
		background: var(--background-color-2) !important;
		border: 1px solid #D13A90 !important;
		font-size: 18px !important;
		font-family: PingFang SC-Regular, PingFang SC !important;
		font-weight: 400 !important;
		color: #D13A90 !important;
		border-radius: 0 !important;
		box-shadow: none !important;
	}
}
.stream_formation_box{
	position: relative;
	.firstIcon{
		margin-right: 42px;
	}
	.inform_tit{
		height:76px;
		font-size:14px;
		font-weight:600;
		color:var(--text-color);
		line-height:20px;
		width: 100%;
		background-color: var(--background-color);
		z-index: 100;
		.cancel_box{
			cursor: pointer;
			width: 150px;
		}
	}
	.informdata_tit{
		text-align: center;
		margin-bottom: 50px;
		height:42px;
		font-size:30px;
		font-family:PingFangSC-Semibold,PingFang SC;
		font-weight:600;
		color:var(--text-color);
		line-height:42px;
	}
	.inMain_box{
		background-color: var(--background-color-4);
		width: 100%;
		box-sizing: border-box;
		padding:50px 30px;
		margin-bottom: 30px;
		.extra_btn{
			width:400px;
			height:60px;
			font-size:26px;
			font-weight:600;
			color:rgba(234,55,150,1);
			line-height:60px;
			text-align: center;
			border: 1px solid rgba(234,55,150,1);
			cursor: pointer;
			// margin: 0 auto;
		}
	}
	.tag_tit{
		height:16px;
		font-size:14px;
		font-family:SFProText;
		font-weight:400;
		color:var(--text-color);
		line-height:16px;
		margin: 30px 0 10px 0;
	}
	.errmsg{
		height:25px;
		font-size:18px;
		font-weight:400;
		color:var(--text-color);
		line-height:25px;
		margin-top: 15px;
	}
}
.stream_formation_box{
	.increaseIcon{
		line-height: 50px !important;
		margin-left: 7px !important;
		font-size: 20px !important;
		font-family: PingFang SC-Regular, PingFang SC !important;
		font-weight: 400 !important;
		color: #FFFFFF !important;
		padding-right: 10px !important;
	}
}
.newDelTit{
	width: 100%;
	text-align: center;
	font-size: 27px;
	color: var(--text-color);
}
.newBtn_list{
	display: flex;
	justify-content: flex-start;
	.newBtn_list{
		margin: 0 !important;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/setting/stream.vue